import { CourseTypes } from '@/models/catalog/course';
import { courseTypesLabels } from '@/constants/catalog/course';
import { AcademicStatusType } from '@/models/learning/academic-situation';

export enum SituationTab {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  Canceled = 'canceled',
}

export const situationTabStatuses: Record<SituationTab, AcademicStatusType[]> = {
  [SituationTab.Pending]: [
    AcademicStatusType.Pending,
    AcademicStatusType.EnrollmentPending,
  ],
  [SituationTab.InProgress]: [AcademicStatusType.InProgress],
  [SituationTab.Completed]: [AcademicStatusType.Completed],
  [SituationTab.Canceled]: [
    AcademicStatusType.Canceled,
    AcademicStatusType.Interrupted,
  ],
};

export const situationTabLabels: Record<SituationTab, string> = {
  [SituationTab.Pending]: 'Pendente',
  [SituationTab.InProgress]: 'Em andamento',
  [SituationTab.Completed]: 'Concluídos',
  [SituationTab.Canceled]: 'Cancelados',
};

export const situationTabOrder: SituationTab[] = [
  SituationTab.Pending,
  SituationTab.InProgress,
  SituationTab.Completed,
  SituationTab.Canceled,
];

export const situationTabsWithoutBadge: SituationTab[] = [
  SituationTab.Completed,
  SituationTab.Canceled,
];

export enum SituationSort {
  Newest = 'newest',
  Oldest = 'oldest',
}

export const situationSortOptions: { value: SituationSort; label: string }[] = [
  { value: SituationSort.Newest, label: 'Início mais recente' },
  { value: SituationSort.Oldest, label: 'Início mais antigo' },
];

export const situationCategoryOptions: { value: CourseTypes; label: string }[] =
  Object.values(CourseTypes).map((courseType) => ({
    value: courseType,
    label: courseTypesLabels[courseType],
  }));
